<template>
  <div v-if="error" class="gate-banner" :class="kind" @click="act">
    <span>{{ message }}</span>
    <b v-if="kind !== 'error'">{{ actionText }} →</b>
  </div>
</template>

<script>
// AI 闸门统一提示：401 未登录 / EXPIRED 到期 / QUOTA 超额 / 其他错误
// 用法：<gate-banner :error="gateError" /> —— 页面 catch 后把 err 存 gateError
export default {
  name: 'GateBanner',
  props: { error: Object }, // {code, msg}
  computed: {
    kind() {
      if (!this.error) return 'error';
      if (this.error.code === 401 || this.error.code === 'AUTH') return 'auth';
      if (this.error.code === 'EXPIRED') return 'expired';
      if (this.error.code === 'QUOTA') return 'quota';
      return 'error';
    },
    message() { return this.error ? this.error.msg : ''; },
    actionText() {
      return { auth: '去登录', expired: '去兑换续费', quota: '查看用量', error: '' }[this.kind];
    },
  },
  methods: {
    act() {
      if (this.kind === 'auth') this.$router.push('/auth?redirect=' + encodeURIComponent(this.$route.fullPath));
      else if (this.kind === 'expired' || this.kind === 'quota') this.$router.push('/profile');
    },
  },
};
</script>

<style scoped>
.gate-banner { border-radius: var(--radius); padding: 12px 16px; font-size: 13px; margin-top: 14px; display: flex; justify-content: space-between; align-items: center; cursor: pointer; }
.gate-banner b { color: var(--text-1); }
.auth { background: var(--primary-a12); border: 1px solid var(--primary-a35); color: var(--accent); }
.expired { background: var(--warn-a12); border: 1px solid var(--warn-a35); color: var(--warn); }
.quota { background: var(--danger-a12); border: 1px solid var(--danger-a35); color: var(--danger); }
.error { background: var(--danger-a10); border: 1px solid var(--danger-a30); color: var(--danger); cursor: default; }
</style>
